import { render, staticRenderFns } from "./WordGroupsForm.vue?vue&type=template&id=503f5bf4&scoped=true&"
import script from "./WordGroupsForm.vue?vue&type=script&lang=js&"
export * from "./WordGroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./WordGroupsForm.vue?vue&type=style&index=0&id=503f5bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f5bf4",
  null
  
)

export default component.exports